// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,body,._1SwcvZdex{min-height:100vh}body{margin:0;display:flex;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";flex-direction:column}#app{flex:1}._1SwcvZdex{display:flex;flex-direction:column;justify-content:center;text-align:center;background-color:#006fc8;color:#ffffff}._5iahfFYgx{padding:0 40px}._1sS8KAZyx{-webkit-animation-name:_3WhO3wWCx;animation-name:_3WhO3wWCx;-webkit-animation-duration:400ms;animation-duration:400ms;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-iteration-count:1;animation-iteration-count:1}@-webkit-keyframes _3WhO3wWCx{0%{opacity:0}100%{opacity:1}}@keyframes _3WhO3wWCx{0%{opacity:0}100%{opacity:1}}._20xC6WDLx{position:absolute;top:40px;left:40px}._1tHBBJNzx{position:absolute;left:40px;bottom:40px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_1SwcvZdex",
	"content": "_5iahfFYgx",
	"title": "_1sS8KAZyx",
	"fadeIn": "_3WhO3wWCx",
	"logo": "_20xC6WDLx",
	"copyright": "_1tHBBJNzx"
};
module.exports = exports;
